import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// A wrapper component that checks if the user is authenticated
// and has the required role before rendering the specified component
const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, currentUser } = useAuth();
  const location = useLocation();
  
  // Check if user is authenticated
  if (!isAuthenticated) {
    // Redirect to login page if not authenticated
    // Pass the current location for redirect after login
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  // If a specific role is required, check if the user has that role
  if (requiredRole && currentUser.role !== requiredRole) {
    // Redirect to unauthorized page if user doesn't have the required role
    return <Navigate to="/unauthorized" replace />;
  }
  
  // If all conditions are met, render the children components
  return children;
};

export default ProtectedRoute;